const RECENTLY_VIEWED_KEY = 'eulua_recently_viewed_products';
const MAX_RECENT_PRODUCTS = 10;
const consentAllowsPersonalization = () => {
  try {
    return JSON.parse(localStorage.getItem('eulua_cookie_consent') || 'null')?.choice === 'accepted';
  } catch {
    return false;
  }
};

export const getRecentlyViewedProductIds = () => {
  if (!consentAllowsPersonalization()) return [];
  try {
    const stored = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    if (!Array.isArray(stored)) return [];
    return stored
      .map(Number)
      .filter((id) => Number.isSafeInteger(id) && id > 0)
      .slice(0, MAX_RECENT_PRODUCTS);
  } catch {
    localStorage.removeItem(RECENTLY_VIEWED_KEY);
    return [];
  }
};

export const rememberRecentlyViewedProduct = (productId) => {
  if (!consentAllowsPersonalization()) return;
  const normalizedId = Number(productId);
  if (!Number.isSafeInteger(normalizedId) || normalizedId < 1) return;
  const updated = [
    normalizedId,
    ...getRecentlyViewedProductIds().filter((id) => id !== normalizedId),
  ].slice(0, MAX_RECENT_PRODUCTS);
  localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(updated));
  window.dispatchEvent(new CustomEvent('recommendationSignalsUpdated', { detail: updated }));
};
